<img alt="close" src="assets/images/svgs/close.svg" />
